import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { getCommentAll,createCommentAll } from '../services/userApi'; // ตรวจสอบให้แน่ใจว่าเส้นทางนี้ถูกต้อง
import backgroundImage from '../assets/Frame_67.jpg';

//img
import DefaultAvatar from '../assets/defaultAvatar.png';

//icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleChevronUp, faCircleChevronDown } from '@fortawesome/free-solid-svg-icons';

const MySwal = withReactContent(Swal);

const AllComment = () => {
    const navigate = useNavigate();
    const [comments, setComments] = useState([]); // เก็บข้อมูลคอมเมนต์
    const [currentPage, setCurrentPage] = useState(1); // หมายเลขหน้าปัจจุบัน
    const [pageSize] = useState(5); // ขนาดของข้อมูลต่อหน้า
    const [totalPages, setTotalPages] = useState(10); // จำนวนหน้าทั้งหมด
    const [loading, setLoading] = useState(true); // สถานะการโหลดข้อมูล    

    const [newComment, setNewComment] = useState('');
    const [replyToCommentUid, setReplyToCommentUid] = useState(null);
    const [replyMessage, setReplyMessage] = useState(''); // ใช้เก็บข้อความตอบกลับ    
    const [user, setUser] = useState(null);
    const onError = (title,response) => {
        MySwal.fire({
            title: title,
            html: response?.data?.error?.message,
            icon: "error",
            confirmButtonText: "Close",
            allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
              if(response?.status===401) {
                  sessionStorage.removeItem('hasVisited');
                  sessionStorage.removeItem('lastPath');        
                  localStorage.removeItem('account');                  
                  navigate('/');
              };
          }
        });
    };

    //Api Comment
    const createCommentApi = async (replyCommentUid, message) => { 
        try {
            const result = await createCommentAll(replyCommentUid, message);     
            if (result.status === true) {
                await loadComments();
                
            } else {
                throw new Error("Cannot create comment. Please try again");
            }
        } catch (error) {            
            // ปรับปรุงการจัดการข้อผิดพลาด
            const errorMessage = error?.response?.data?.message || "An unexpected error occurred";
            onError("Create comment error", errorMessage);
        }
    };

    const handleCreateComment = async (event) => {
        event.preventDefault();
        if (newComment.trim()) {
            await createCommentApi( null, newComment);
            setNewComment('');
            //setReplyToCommentUid(null);            
        } else {
            onError('ข้อผิดพลาด', 'กรุณากรอกข้อความความคิดเห็น');
        }
    };    

    const handleCommentChange = (event) => {
        setNewComment(event.target.value);
    };  

    //reply
    const toggleReply = (commentUid) => {
        setReplyMessage('');
        setReplyToCommentUid(prev => (prev === commentUid ? null : commentUid));
    };    
    const handleReplySubmit = async (event, commentUid) => {
        event.preventDefault();
        if (replyMessage.trim()) {
            await createCommentApi(commentUid, replyMessage);
            setReplyMessage('');
            setReplyToCommentUid(null);            
        } else {
            onError('ข้อผิดพลาด', 'กรุณากรอกข้อความความคิดเห็น');
        }
    };    
    const handleReplyChange = (event) => {
        setReplyMessage(event.target.value);
    };    

    const loadComments = async () => {
        setLoading(true);
    
        try {
            const response = await getCommentAll(currentPage, pageSize);
            if (response && response.status === true && response.data && Array.isArray(response.data.main_comments)) {
                setComments(response.data.main_comments); // อัพเดตผลลัพธ์
                setTotalPages(response.data.total_page); // อัพเดตจำนวนหน้า
    
                // เพิ่ม log เพื่อตรวจสอบจำนวนหน้า
                console.log('Total pages:', response.data.total_page);
                console.log('Total pages:', response.data.main_comments);
            } else {
                throw new Error('Invalid data structure');
            }
        } catch (error) {
            console.error('Error fetching courses:', error);
            onError('Error', error?.response || { data: { error: { message: 'An unexpected error occurred' } } });
        } finally {
            setLoading(false);
        }
    };
    
        // ดึงข้อมูลคอมเมนต์เมื่อ currentPage หรือ pageSize เปลี่ยน
        useEffect(() => {
            loadComments(); // โหลดข้อมูลใหม่เมื่อเปลี่ยนหน้า หรือ pageSize
        }, [currentPage, pageSize]);

        // ตั้งค่า user จาก localStorage ตอน mount
        useEffect(() => {
            const storedUser = JSON.parse(localStorage.getItem('account'));
            if (storedUser) {
                setUser(storedUser); // ตั้งค่า user
            }
        }, []); // ทำงานครั้งเดียวตอน mount


    const getPaginationItems = () => {
        const pages = [];
        const maxPagesToShow = 5;
        const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

        let startPage = Math.max(1, currentPage - halfMaxPagesToShow);
        let endPage = Math.min(totalPages, currentPage + halfMaxPagesToShow);

        if (currentPage - halfMaxPagesToShow <= 0) {
            endPage = Math.min(totalPages, endPage + (halfMaxPagesToShow - currentPage + 1));
        }

        if (currentPage + halfMaxPagesToShow >= totalPages) {
            startPage = Math.max(1, startPage - (halfMaxPagesToShow - (totalPages - currentPage)));
        }

        for (let page = startPage; page <= endPage; page++) {
            pages.push(page);
        }

        return pages;
    };

    const onPageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page); // อัปเดต currentPage
            console.log("Page changed to:", page); // Debug log
        }
    };
    
    
    return (
        <div>
            {/* Background Section */}
            <div style={styles.background}></div>
            
            {/* Main Container */}
            <div style={styles.container}>
                {/* Inquiry Section */}
                <div style={styles.containerComment}>
                    <p
                        style={{
                            textAlign: 'left',
                            fontSize: '1.4vw',
                            margin: 0,
                            fontWeight: 'bold',
                        }}
                    >
                        สอบ-ถามรวม
                    </p>
    
                    {/* Comment Post Section */}
                    <div
                        style={{
                            backgroundColor: '#f2f2f2',
                            border: '1px solid #dddddd',
                            padding: '24px',
                            borderRadius: '16px',
                            boxSizing: 'border-box',
                            margin: '24px 0',
                        }}
                    >
                        {user ? (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    textAlign: 'left',
                                }}
                            >
                                <img
                                    src={user.image_url ? user.image_url : DefaultAvatar}
                                    alt="Profile"
                                    style={{
                                        width: '2vw',
                                        height: '2vw',
                                        borderRadius: '50%',
                                        marginRight: '10px',
                                    }}
                                />
                                <span>
                                    {user.first_name} {user.last_name}
                                </span>
                            </div>
                        ) : (
                            'โปรไฟล์'
                        )}
                        
                        <form onSubmit={handleCreateComment}>
                            <textarea
                                value={newComment}
                                onChange={handleCommentChange}
                                placeholder="สอบถาม..."
                                rows="3"
                                style={{
                                    padding: '10px',
                                    width: '100%',
                                    fontSize: '16px',
                                    color: 'black',
                                    backgroundColor: 'white',
                                    borderRadius: '20px',
                                    resize: 'none',
                                    border: 'none',
                                    boxSizing: 'border-box',
                                    fontFamily: 'Kanit, sans-serif',
                                    overflow: 'auto',
                                    marginTop: '20px',
                                }}
                            />
                            
                            <div
                                style={{
                                    width: '100%',
                                    marginTop: '12px',
                                }}
                            >
                                <button
                                    type="submit"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        backgroundColor: '#44526E',
                                        color: '#fff',
                                        fontSize: '1vw',
                                        border: 'none',
                                        borderRadius: '64px',
                                        fontFamily: 'Kanit, sans-serif',
                                        cursor: 'pointer',
                                    }}
                                >
                                    โพสต์
                                </button>
                            </div>
                        </form>
                    </div>
                    
                    <hr />
    
                    {/* Questions Section */}
                    <div>
                        <p
                            style={{
                                textAlign: 'left',
                                fontSize: '1.4vw',
                                marginTop: '20px',
                                fontWeight: 'bold',
                            }}
                        >
                            คำถามทั้งหมด
                        </p>
                        
                        <ul style={{ listStyleType: 'none', padding: '0' }}>
                            {comments.map((comment, index) => (
                                <li
                                    key={`comment-${comment.uid}`}
                                    style={{
                                        marginBottom: '16px',
                                        textAlign: 'left',
                                        backgroundColor: '#f2f2f2',
                                        border: '1px solid #dddddd',
                                        padding: '24px',
                                        borderRadius: '16px',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px',
                                        }}
                                    >
                                       <div style={styles.commentcontainer}>
                                                <div style={{ width: '95%' }}>
                                                    <div style={{ display:'flex' , alignItems:'center'}}>
                                                        <img
                                                            src={comment.image_url ? comment.image_url : DefaultAvatar}
                                                            alt="Profile"
                                                            style={{
                                                                width: '2vw',
                                                                height: '2vw',
                                                                borderRadius: '50%',
                                                            }}
                                                            />
                                                            <p style={{
                                                                padding: '10px',
                                                                color: 'black',
                                                                borderRadius: '20px',
                                                                boxSizing: 'border-box',
                                                                whiteSpace: 'pre-wrap',
                                                                wordWrap: 'break-word',
                                                                margin:0,
                                                                fontSize:'1vw'
                                                            }}>
                                                                {comment.first_name} {comment.last_name}
                                                            </p> 
                                                            <p style={{
                                                                color: '#44526e',
                                                                borderRadius: '20px',
                                                                boxSizing: 'border-box',
                                                                whiteSpace: 'pre-wrap',
                                                                wordWrap: 'break-word',
                                                                margin:0,
                                                                fontSize:'1vw'}}>
                                                                   - {comment.role === 'admin' ? 'แอดมิน' : comment.role === 'teacher' ? 'อาจารย์' :  comment.role === 'student'? 'นักเรียน' : 'ไม่ระบุ'}
                                                            </p>
                                                    </div>
                                                            <p><span>{comment.message}</span></p>
                                                </div>
                                                <div style={{ display: 'flex', width: '100%' }}>
                                                    <button
                                                        onClick={() => toggleReply(comment.uid)}
                                                        style={{
                                                            width: '100%',
                                                            color:'#44526E',
                                                            fontSize: '36px',
                                                            border: 'none',
                                                            fontFamily: 'Kanit, sans-serif',
                                                            cursor: 'pointer',
                                                            background: 'none',
                                                            textAlign: 'right',
                                                            display: 'flex', // ใช้ flexbox เพื่อจัดตำแหน่ง
                                                            flexDirection: 'column', // จัดตำแหน่งให้ไอคอนอยู่บน
                                                            alignItems: 'flex-end', // จัดไอคอนไปที่ขวา
                                                            
                                                        }}
                                                    >
                                                        {replyToCommentUid === comment.uid ? (
                                                            <>
                                                                <FontAwesomeIcon icon={faCircleChevronUp} style={{ marginBottom: '5px', }} />
                                                            </>
                                                        ) : (
                                                            <>
                                                                <FontAwesomeIcon icon={faCircleChevronDown} style={{ marginBottom: '5px' }} />
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
    
                                        {/* Main Content Section */}
                                        <div
                                        >
                                              {/* Reply Section */}
                                            {replyToCommentUid === comment.uid && (
                                                <div>
                                                <hr />
                                                <p style={{
                                                    textAlign: 'left',
                                                    fontSize: '1.4vw',
                                                    marginTop: '20px',
                                                    fontWeight: 'bold'
                                                }}>การตอบกลับ</p>
                                                <div style={{ padding: '0 100px',boxSizing:'border-box'}}>
                                                    <div style={{ marginBottom: '10px' }}>
                                                    {/* Show replies */}
                                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                                        {comment.replies.map((reply) => (
                                                        <li key={reply.uid} style={{ marginBottom: '10px' }}>
                                                            <div style={{ width: '100%',background:'white' ,padding:'10px',boxSizing:'border-box',borderRadius:'16px'}}>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <img
                                                                src={reply.image_url ? reply.image_url : DefaultAvatar}
                                                                alt="Profile"
                                                                style={{
                                                                    width: '2vw',
                                                                    height: '2vw',
                                                                    borderRadius: '50%',
                                                                }}
                                                                />
                                                                <p style={{
                                                                padding: '10px',
                                                                color: 'black',
                                                                borderRadius: '20px',
                                                                boxSizing: 'border-box',
                                                                whiteSpace: 'pre-wrap',
                                                                wordWrap: 'break-word',
                                                                margin: 0,
                                                                fontSize: '1vw'
                                                                }}>
                                                                {reply.first_name} {reply.last_name}
                                                                </p>
                                                                <p style={{
                                                                color: '#44526e',
                                                                borderRadius: '20px',
                                                                boxSizing: 'border-box',
                                                                whiteSpace: 'pre-wrap',
                                                                wordWrap: 'break-word',
                                                                margin: 0,
                                                                fontSize: '1vw'
                                                                }}>
                                                                - {reply.role === 'admin' ? 'แอดมิน' : reply.role === 'teacher' ? 'อาจารย์' : reply.role === 'student' ? 'นักเรียน' : 'ไม่ระบุ'}
                                                                </p>
                                                            </div>
                                                            <p><span>{reply.message}</span></p>
                                                            </div>
                                                        </li>
                                                        ))}
                                                    </ul>
                                                    </div>
                                                    <div style={{ marginTop: '10px', background: '#e1e1e1', padding: '10px', borderRadius: '20px', border: '1px solid #cccccc' }}>
                                                    <form onSubmit={(e) => handleReplySubmit(e, comment.uid)}>
                                                        <p style={{
                                                        fontSize: '1vw',
                                                        color: 'black',
                                                        margin: '0 0 10px 0',
                                                        }}>
                                                        {comment.username}
                                                        </p>
                                                        <textarea
                                                        value={replyMessage}
                                                        onChange={handleReplyChange}
                                                        rows="3"
                                                        style={{
                                                            padding: '10px',
                                                            width: '100%',
                                                            fontSize: '16px',
                                                            color: 'black',
                                                            backgroundColor: '#F9FAFB',
                                                            borderRadius: '20px',
                                                            resize: 'none',
                                                            border: 'none',
                                                            marginBottom: '10px',
                                                            boxSizing: 'border-box',
                                                            fontFamily: 'Kanit, sans-serif',
                                                        }}
                                                        placeholder="ตอบกลับ..."
                                                        />
                                                        <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                                                        <button
                                                            type="submit"
                                                            style={{
                                                            width: '100%',
                                                            padding: '10px',
                                                            backgroundColor: '#44526E',
                                                            color: '#fff',
                                                            fontSize: '1vw',
                                                            border: 'none',
                                                            borderRadius: '64px',
                                                            fontFamily: 'Kanit, sans-serif',
                                                            cursor: 'pointer',
                                                            }}
                                                        >
                                                            ตอบกลับ
                                                        </button>
                                                        </div>
                                                    </form>
                                                    </div>
                                                </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            {/* Pagination Section */}
            <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div style={styles.pagination}>
                        <span
                            style={{
                                ...styles.paginationItem,
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                color: currentPage === 1 ? '#ccc' : 'white',
                                fontSize: '30px',
                                textDecoration: 'none',
                            }}
                            onClick={() => onPageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            &lt;
                        </span>
                        {getPaginationItems().map((page) => (
                            <span
                                key={page}
                                style={{
                                    ...styles.paginationItem,
                                    ...(currentPage === page
                                        ? styles.activePaginationItem
                                        : {}),
                                }}
                                onClick={() => onPageChange(page)}
                            >
                                {page}
                            </span>
                        ))}
                        <span
                            style={{
                                ...styles.paginationItem,
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                color: currentPage === totalPages ? '#ccc' : 'white',
                                fontSize: '30px',
                                textDecoration: 'none',
                            }}
                            onClick={() => onPageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            &gt;
                        </span>
                    </div>
                </div>
       </div>
    );    
};

const styles = {
    background: {
        position: 'fixed',
        width: '100%',
        height: '100%',
        top: '0',
        left: '0',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: '-1',
    },
    container :{
        paddingTop: '110px',
        width: '90%',
        boxSizing: 'border-box',
        display: 'flex',             // Enable flexbox layout
        justifyContent: 'center',    // Center horizontally
        alignItems: 'center',        // Center vertically
        margin: '0 auto',            // This ensures the container is centered horizontally
        
    },
    containerComment:{
        width:'100%',
        backgroundColor: 'rgba(242, 242, 242, 0.5)',
        padding:'24px',
        borderRadius:'36px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',  // จัดให้อยู่ตรงกลางในแนวนอน
        alignItems: 'center',  // จัดให้อยู่ตรงกลางในแนวตั้ง
        margin: '20px 0',  // เพิ่มระยะห่างจากตาราง
        background: 'linear-gradient(90deg, #7C93B7 0%, #374151 100%)',
        width: '80%',
        borderRadius: '64px',  // เพิ่มขอบมนเล็กน้อยให้กับ pagination
        boxSizing: 'border-box',  // ทำให้ขนาดกล่องรวม padding และ border
    },
    
    paginationItem: {
        margin: '0 20px',
        cursor: 'pointer',
        fontSize: '16px',
        color: 'white',
        textDecoration: 'none',
    },    
    activePaginationItem: {
        backgroundColor: '#44526E',
        color: 'white',
        width: '100%',
        maxWidth:'56px',
        height:'56px',
        borderRadius: '34px',  
        padding: '5px',
        fontSize: '24px',
        textAlign:'center',
        display: 'flex',
        justifyContent: 'center',  // จัดให้อยู่ตรงกลางในแนวนอน
        alignItems: 'center',  // จัดให้อยู่ตรงกลางในแนวตั้ง
    },
    commentcontainer:{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        boxSizing: 'border-box',  // ใช้ boxSizing: 'border-box' เพื่อรวม padding และ border เข้าไปในขนาดรวม
        padding: 0,  // กำหนดให้ไม่มี padding
        margin: 0,   // กำหนดให้ไม่มี margin
    },
};

export default AllComment;
